import React from "react";
import { Field } from "formik";
import { cn } from "../lib/utils";

const RadioButton = ({ name, value, label }) => {
  return (
    <Field name={name}>
      {({ field }) => (
        <label className="cursor-pointer select-none">
          <input
            type="radio"
            {...field}
            value={value}
            checked={field.value === value}
            className="sr-only peer"
          />
          <span className={cn(
            "inline-flex items-center px-4 py-2 text-sm font-medium rounded-lg border-2 transition-all duration-150",
            "border-border/60 text-foreground",
            "hover:border-primary/50 hover:bg-primary/5",
            "peer-checked:border-primary peer-checked:bg-primary peer-checked:text-primary-foreground peer-checked:shadow-sm"
          )}>
            {label}
          </span>
        </label>
      )}
    </Field>
  );
};

export default RadioButton;
